export default "__VITE_ASSET__1QBA9YbH__"